import initEnvironments from '~/environments/index';

const el = document.getElementById('environments-table');

initEnvironments(el);
